export default {
  CREATE: 'CREATE_MESSAGE_LIKE',
  DESTROY: 'DESTROY_MESSAGE_LIKE'
};
